const pointNumberFilter = function(input) {
  if(input==null&&input==undefined){
    return input
  }
  let v = input+'';
  if(v!=''&&v.indexOf('.')<0){
    return v+'.00'
  }else if(v!=''&&v.indexOf('.')>0&&v.split('.')[1].length=='1'){
    return v+'0'
  }else if(v!=''&&v.indexOf('.')>0&&v.split('.')[1].length=='2'){
    return v
  }

}

let filterObj = {}
filterObj.pointNumber = pointNumberFilter

export default filterObj
